import { Skeleton } from '@mui/material'
import { ReactNode, useContext } from 'react'
import { DocumentationContext } from '../../context'

interface DocPageHandlerProps {
    children: ReactNode
}

export default function DocPageHandler({children}: DocPageHandlerProps) {
    const context = useContext(DocumentationContext)
    return (<div style={{ width: '100%', display: 'flex', flexDirection: 'column', margin: 0 }}>
        {(context?.loadingPage || (!context?.loadingPage && !context?.page)) && <div className='d-flex-center w-100' style={{ height: '90%' }}>
            <Skeleton title="skeleton" variant="rectangular" className='m-auto' width="90%" height="90%" />
        </div>}
        {context?.page && children}
    </div>
    )
}
